import React, { ReactNode, useEffect, useRef, useState } from "react";
import { DownCaret,LeftCaret } from "./Icons/Carets";
import { RightCaret } from "vagaro-website-rendering/src/components/Icons/Carets";



export default function SelectDropdown({additionalStyle,options,defaultValue,onChange,expandToRight,optionHeight,hideSelectedInMenu,allowFilter,footer,useExpanders}:{footer?:ReactNode,options:{label:ReactNode,value:string,isDivider?:boolean,isAdvanced?:boolean,rawLabel?:string}[],defaultValue:string,onChange:(val:string)=>void,expandToRight?:boolean,optionHeight?:number,additionalStyle?:{},hideSelectedInMenu?:boolean,allowFilter?:boolean,useExpanders?:boolean}){

    const defaultItemHeight =optionHeight?? 48;
    let defaultVal = 0;
    const [filterVal,setFilter] = useState("");
    

    const filterSplit = filterVal.split(" ");
    for(let i = 0;i<options.length;i++){
        if(options[i].value == defaultValue&&!options[i].isDivider){
            defaultVal = i;
            break;
        }
    }

    const selectRef = React.createRef<HTMLDivElement>();
    const [flipped,setFlipped] = useState(false);
    const [filterAdvanced,setFilterAdvanced] = useState(false);
    const scrollRef =  useRef(-1);
    const [selected,setSelected] = useState(defaultVal);
    const [collapsedList,setCollapsedList] = useState<string[]>([]);
    let hasAdvanced = false;
    const [isOpen,setIsOpen] = useState(false);
    const filterdCount = useRef(0)
    const handleClickOutside = (e:MouseEvent)=>{

        if(selectRef.current){

            let content =selectRef.current.querySelector(".select-dropdown-options");

            if(!content)
                return;
            let bounds = content.getBoundingClientRect();
            if(e.clientX<bounds.left||e.clientX>bounds.right||e.clientY<bounds.top||e.clientY>bounds.bottom){
                setIsOpen(false);

                }
        }

    }

    useEffect(()=>{
        if(isOpen && allowFilter){
            setFilter("");
            let input = selectRef.current?.querySelector("#select-filter-search") as HTMLInputElement;
            if(input)
                input.focus();
        }
//eslint-disable-next-line
    },[isOpen])

    useEffect(()=>{

        if(selectRef.current){
            let pos = selectRef.current.getBoundingClientRect().bottom;

            let height = window.innerHeight;
            let tempflipped =false;
            if(pos>height*.5){
                tempflipped = true;
            }

            if(tempflipped!=flipped){
                setFlipped(tempflipped);
            }

        }
//eslint-disable-next-line
    },[isOpen]);
    
    const isFilteredOption =(option: { label: ReactNode; value: string; isDivider?: boolean; rawLabel?: string; })=> {


        let str =(option.rawLabel)?option.rawLabel:(option.label as string);
            
        if(filterVal.length<1)
            return true;

        let found = false;
        if(str && typeof str === "string"){
         
            for(let f = 0;f<filterSplit.length;f++){
                let filt = filterSplit[f];
                if(filt.length>0){
                    if(str.toLowerCase().includes(filt.toLowerCase())){
                        found =  true;
                    }
                    else{
                        return false;
                    }
                }

            }

            

        }
    
        return found;
        
    }
    const handleKeyEvents =(e:KeyboardEvent)=>{

        if(isOpen){


            if(e.key == "ArrowDown"){
                if(allowFilter&&filterdCount.current==0)
                    return;

  
                let newSelection = selected;

            do{
               newSelection = (newSelection+1)%options.length;

                if(options[newSelection].isDivider){
                    newSelection = (newSelection+1)%options.length;
                }

            }
            while(
                allowFilter && filterVal.length>0 && filterdCount.current>0 &&
                !isFilteredOption(options[newSelection])
            )
     
        

                setSelected(newSelection);
                onChange(options[newSelection].value);

                
        
           
                e.preventDefault();
            }
            else if(e.key == "ArrowUp"){
                
                let newSelection = selected;

                do{
                newSelection = (newSelection-1)%options.length;
                if(newSelection<0)
                    newSelection = options.length-1;

                if(options[newSelection].isDivider){
                    newSelection = (newSelection-1)%options.length;
                }
                if(newSelection<0)
                newSelection = options.length-1;
            }
            while(
                allowFilter && filterVal.length>0 && filterdCount.current>0 &&
                !isFilteredOption(options[newSelection])
            )
                
                setSelected(newSelection);
                onChange(options[newSelection].value);
    
                e.preventDefault();
            }
            else if(e.key == "Enter"){
                if(!options[selected].isDivider){

                    onChange(options[selected].value);
                    setSelected(selected);
                    setIsOpen(false);
                }
            }
            else if(e.key == "Escape"){

                setIsOpen(false);
            }
            //jumpt to option on key press
            else if(e.key.length === 1&&!allowFilter){

                let currentSelection = selected+1;

                for(let i = 0;i<options.length;i++){
                    
                    
                    let index = (currentSelection+i)%options.length;

                    let str = (options[index].label as string);
                

                    if(!str || typeof str !== "string")
                        str = options[index].value;

                  
                    str = str.toLowerCase();

                    if(str.startsWith(e.key.toLowerCase()) && !options[i].isDivider){
                        setSelected(index);
                        onChange(options[index].value);
                  
                        break;
                    }
                }
           

            }
            
        }

    }


    const toggleMenu = ()=>{



        setIsOpen(!isOpen)

    }

    const saveScroll = (e:any)=>{

        let target = e.target;

        if(target)
            scrollRef.current = target.scrollTop;



    }
    useEffect(()=>{


        document.addEventListener("keydown",handleKeyEvents);
        window.addEventListener("mousedown",handleClickOutside);

        if(isOpen && selectRef.current){


            let container = selectRef.current.parentElement?.querySelector(".select-scroll-conantainer");
            
            if(container){

                const num = selected + (allowFilter?-1:0);
                container.addEventListener("scroll",saveScroll);

                if(scrollRef.current < 0){
           
                    container.scrollTop = num*defaultItemHeight - 50;
                }
                else{
                    container.scrollTop = scrollRef.current;
                }

            }

        }


        return ()=>{
//eslint-disable-next-line
            if(selectRef.current){//eslint-disable-next-line
                let container = selectRef.current.parentElement?.querySelector(".select-scroll-conantainer");
                if(container)
                    container.removeEventListener("scroll",saveScroll);
            }

            document.removeEventListener("keydown",handleKeyEvents);
            window.removeEventListener("mousedown",handleClickOutside);
        }
    });

     filterdCount.current = 0;

    if(selected>=options.length&&selected!=0){
        setSelected(0);
        if(options.length>0)
        onChange(options[0].value);
        return <></>
    }

 
    let isCollapsed = false;

    const fstyling = (flipped)?{
        top:"auto",
        bottom:"80%",
      

    }:{};
    

    return (

        <>
        <div className="select-dropdown-container" ref = {selectRef}>
            <div className={"select-dropdown " +(flipped?"flipped":"")}style={additionalStyle??{}} onClick={()=>{toggleMenu()}}>{options[selected].label} <span className="down"><DownCaret/></span></div>
            {isOpen&&
            <div className={"select-dropdown-options flex-column block-edit "+(allowFilter?"filtered":"")+((flipped)?" flipped":"") }
                key={"select-dropdown-options-"+selected}
            style={(expandToRight)?{left:"0px",...fstyling}:{right:"0px",...fstyling}}
           
            >
                  {allowFilter && 
                 <div className="select-filter-input w-full" >
                     <input autoComplete="off" type="text" id="select-filter-search" className="w-full"  placeholder="Search" style={{padding:"8px 8px 8px 32px",borderRadius:"3px"}}
                  onInput={(e)=>{setFilter(e.currentTarget.value);}}
                  
                  ></input>
                  <div style={{position:"absolute",left:"4px",top:"4px"}}>
                    <SearchIcon/>
                  </div>
                  </div> }
               <div className="flex-column max-100 select-scroll-container" style={{overflow:"auto"}}>
                {
       
                    options.map((option,index)=>{
     
                        if(
                            allowFilter && 
                            !isFilteredOption(option)
                            ){

                            return null;
                        }

                        if(allowFilter&&option.isDivider && filterVal.length>0)
                            return  null;

                        else if(hideSelectedInMenu && index == selected)
                            return null;

                        filterdCount.current++;

                        const slectedClass = (index == selected)?" selected":"";
                   
                        if(option.isAdvanced){
                            hasAdvanced = true;
                            if(!filterAdvanced){
                                return null;
                            }
                        }

                        if(filterAdvanced && !option.isAdvanced)
                            return null;
                   

                        if(option.isDivider){

                           
                             let dval = option.label+index.toString();
                          


                            if(collapsedList.includes(dval)){
                                isCollapsed = true;
                            }
                            else{
                                isCollapsed = false;
                            }

                           return  <div

                           onClick={ (e)=>{
                            if(useExpanders){
                                let list = [...collapsedList];
                                if(list.includes(dval)){
                                    list = list.filter((v)=>v!=dval);
                                }
                                else{
                                    list.push(dval);
                                }   
                          
                                setCollapsedList(list);
                           } }}
                            style={{color:(useExpanders?"black":"var(--input-selected-primary)"),fontWeight:"normal",padding:"12px"}} 
                       className={"invisible-button " } 
                       key={index}
                       id={"select-dropdown-option-"+index}
                     
                       > 
                       {useExpanders&&<>
                        <div style={{width:"16px",fontSize:"18px",display:"inline-block"}}>{isCollapsed?<RightCaret/>:<DownCaret/>

                        }</div>
                       
                       </>

                       }
                        {option.label}
                        </div>
                        }

                        

                        if(isCollapsed&& filterVal.length<3)
                            return null;

                       return <button 
                       className={"invisible-button"+slectedClass } 
                       key={index}
                       style={useExpanders?{paddingLeft:"28px"}:{}}
                       id={"select-dropdown-option-"+index}
                       onClick={()=>{onChange(options[index].value);setSelected(index);setIsOpen(false)}}
                       >
                        {option.label}
                        </button>



                    })
                        
                }
                 {
                            hasAdvanced&&<button className="invisible-button" onClick={()=>{setFilterAdvanced(!filterAdvanced)}}>{filterAdvanced?<><LeftCaret/>&nbsp;Back</>:<>Advanced&nbsp;<RightCaret/></>}</button>
                        
                }
                {footer}
                </div>

                { filterVal.length>0&& allowFilter && filterdCount.current == 0 && <div className="center-all select-footer font-small" style={{padding:"4px"}}>No Results</div>}

                { filterVal.length>0&& allowFilter && filterdCount.current == 1 && <div className="center-all select-footer font-small" style={{padding:"4px"}}>1 Result</div>}

                { filterVal.length>0&& allowFilter && filterdCount.current > 1 && <div className="center-all  select-footer font-small" style={{padding:"4px"}}>{filterdCount.current} Results</div>}

                

            </div>
            }
        </div>
        </>

    )
}

export function SearchIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="currentColor" style={{ position: "absolute", left: "14px", top: "16px", pointerEvents: "none" }}><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" /></svg>
}